import React from "react";
import { Link } from "react-router-dom";

import { MdAdd } from "react-icons/md";

const TrainingCardNew = () => {
  return (
    <Link className="shadow-lg p-4 w-80 bg-white m-2 hover:scale-105" to='/training/new'>
      <div className="flex">
        <MdAdd className="bg-rose-300 rounded-full h-10 w-10 p-2" color="white" />
        <div className="flex-1 ml-2">
          <h6 className="text-slate-600 font-medium capitalize m-0 p-0">
            Nouvelle formation
          </h6>
          <p className="text-slate-400 text-xs">Créez une nouvelle formation</p>
        </div>
      </div>
    </Link>
  );
}

export default TrainingCardNew